module.exports = __webpack_public_path__ + "img/16fbb9c53a8779a1ff498b4c78e5f764.25a77542.jpg";